import React from 'react';
import { useSelector } from 'react-redux';
import { State } from '../../reducers';
import { CircularProgress, createStyles, Grid, makeStyles, Modal, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: 'absolute',
      width: 100,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
  }),
);

/** 検索画面で検索処理の実行中であることを表すアイコン（ぐるぐるアイコン）のコンポーネント。 */
const LoadingModal: React.FC = () => {
  const classes = useStyles();
  /** 検索処理中であるかを表すフラグ。 */
  const isLoading = useSelector((state: State) => state.general.isLoading);

  return (
    // Modalコンポーネントの「disableAutoFocus」「disableEnforceFocus」の2オプションを設定していない場合、
    // 選択状態の青枠が表示されてしまうためオプションを設定している。
    <Modal open={isLoading} disableAutoFocus disableEnforceFocus>
      <div className={classes.paper}>
        <Grid container justify='center' alignContent='center'>
          <Grid item>
            <CircularProgress color='primary' size={72}/>
          </Grid>
        </Grid>
      </div>
    </Modal>
  )
}

export default LoadingModal;
